import { Injectable } from '@angular/core';
import { HttpDataService } from '../../../../shared/http/http-data.service';

import { ICountry } from '../../../../../type_definitions/datatypes';

export interface ITerritory {
  id?:number;
  country:ICountry;
  remove?:boolean;
}

@Injectable()
export class BPProfilesTerritoriesDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {
    /**/
  }

  public getTerritories(profileId:number):Promise<ITerritory[]> {
    return this.httpDataService.doGET(
      `rest/bpprofiles/profiles/${profileId}/territories`,
      undefined,
      undefined,
      'Error loading territories'
    );
  }

  public saveTerritories(profileId:number, territories:ITerritory[]):Promise<ITerritory[]> {
    return this.httpDataService.doPUT(
      `rest/bpprofiles/profiles/${profileId}/territories`,
      undefined,
      territories,
      undefined,
      'Error saving territories'
    );
  }
}